import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { SearchClientComponent } from 'src/app/components/search-client/search-client.component';
import { ClientExtendsComponent } from 'src/app/sale/client/client-extends/client-extends.component';
import { GeneralService } from 'src/app/api/config/general.service';
import * as moment from 'moment';
import { SearchAvailableBedroomsExtendsComponent } from 'src/app/components/search-available-bedrooms-extends/search-available-bedrooms-extends.component';
import { GuestsExtendsComponent } from '../../guests/guests-extends/guests-extends.component';
import { constants } from 'src/app/constants';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
import { HotelbookingsService } from 'src/app/api/hotelbooking/hotelbookings.service';
import { HttpHeaders } from '@angular/common/http';
declare var $: any;
import flatpickr from 'flatpickr';
import { RoomtypeService } from 'src/app/api/hospitality/roomtype.service';
import { SearchPartnercompaniesComponent } from 'src/app/components/search-partnercompanies/search-partnercompanies.component';

@Component({
  selector: 'app-hotelbookings-form',
  templateUrl: './hotelbookings-form.component.html',
  styleUrls: ['./hotelbookings-form.component.css']
})
export class HotelbookingsFormComponent implements OnInit {
  @ViewChild(SearchClientComponent) SearchClientComponent: any;
  @ViewChild(ClientExtendsComponent) ClientExtendsComponent: any;
  @ViewChild(GuestsExtendsComponent) GuestsExtendsComponent: any;
  @ViewChild(SearchAvailableBedroomsExtendsComponent)
  SearchAvailableBedroomsExtendsComponent: any;
  @ViewChild(SearchPartnercompaniesComponent)
  SearchPartnercompaniesComponent: any;

  private thisComponent: HotelbookingsFormComponent;
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  clientSelected: any = null;
  companyAgreement: any = null;
  flatpickrStart: any;
  flatpickrEnd: any;
  bedroomSelected: any = null;
  typeRateObj: any = constants.HOTEL.TYPE_RATES[0];

  selectedFiles: File[] = [];

  //init variables
  originsbooking: any = [];
  arrivalplaces: any = [];
  vehiclestours: any = [];
  shifttours: any = [];
  workinggroups: any = [];
  roomtypes: any = [];
  type_rates: any = [];
  type_charges: any = [];

  // array detail booking
  detail_bedrooms: any = [];
  detail_guests: any = [];
  detail_transfers: any = [];

  // totales
  total: any = 0;
  total_bedrooms: any = 0;
  total_pax: any = 0;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private roomtypeService: RoomtypeService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private generalService: GeneralService,
    private alert: SwalAlert,
    public toolsService: ToolsService,
    private hotelbookingService: HotelbookingsService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.thisComponent = this;
    this.item = this.fb.group({
      client_id: [null, [Validators.required]],
      partnercompany_id: [null],
      is_client_guest: [false],
      bookingorigin_id: [1, [Validators.required]],
      arrivalplace_id: [null],
      typerate_id: this.typeRateObj.id,
      tel_1: [null],
      arrival_place: [null],
      tel_2: [null],
      is_agreement: [false],

      // para totales
      text_amount: [null],
      total: [null]
    });

    this.type_rates = constants.HOTEL.TYPE_RATES;

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    this.getTypeChargeHotel();
    this.getRoomTypes();
    this.getOriginBooking();
    this.getArrivalBooking();
    if (this.isEdit) {
      this.editData();
    } else {
      // aca si es nuevo
    }
  }

  editData() {
    this.hotelbookingService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        console.log('datos de edicion');
        console.log(item_);

        this.item.patchValue({
          typerate_id: item_.ratetype_id
        });

        // cliente responsable de la reserva
        this.selectedClientSearch(item_.client_data);

        // detalle de habitaciones de la reserva
        for (let i in item_.blockbedrooms) {
          this.detail_bedrooms.push(item_.blockbedrooms[i]);
          setTimeout(() => {
            this.initialRoomTypeBedroom(i);
            this.setDateflatpickrBedroom(i, this.thisComponent);
          }, 100);
        }
        this.calculateTotal();

        // huespedes de la reserva
        this.detail_guests = item_.guests;
        // huespedes de la reserva
        //  this.detail_transfers = item_.detail_transfers;
        for (let i in item_.detail_transfers) {
          let item_transfer = item_.detail_transfers[i];
          this.detail_transfers.push(item_transfer);

          setTimeout(() => {
            // inicializar tipo de traslado
            var index = this.detail_transfers.indexOf(item_transfer);
            let options_typetransfers = constants.HOTEL.TRANSFERS;
            (<any>$('#typeTransferSelected' + index)).html('');
            for (let i in options_typetransfers) {
              let item_ = options_typetransfers[i];
              (<any>$('#typeTransferSelected' + index)).append(
                $('<option>', {
                  value: item_.id,
                  text: item_.description
                })
              );
            }
            (<any>$('#typeTransferSelected' + index)).val(
              item_transfer.typetransfer_id
            );
            this.detail_transfers[index].typetransfer_id =
              item_transfer.typetransfer_id;

            // inicializar lugar|llegada de traslado ======================
            var options = this.arrivalplaces;
            (<any>$('#arrivalPlaceSelected' + index)).html('');
            for (let i in options) {
              let item_ = options[i];
              (<any>$('#arrivalPlaceSelected' + index)).append(
                $('<option>', {
                  value: item_.id,
                  text: item_.description
                })
              );
            }
            (<any>$('#arrivalPlaceSelected' + index)).val(
              item_transfer.placetransfer_id
            );
            this.detail_transfers[index].placetransfer_id =
              item_transfer.placetransfer_id;
          }, 50);
        }
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  // FUNCTIONS LOADS DATAS

  getOriginBooking() {
    this.generalService.listOriginBooking().subscribe({
      next: (data: any) => {
        this.originsbooking = data;
      }
    });
  }

  getArrivalBooking() {
    this.generalService.listArrivalBooking().subscribe({
      next: (data: any) => {
        this.arrivalplaces = data;
      }
    });
  }

  getRoomTypes() {
    this.roomtypeService.all().subscribe({
      next: (data: any) => {
        this.roomtypes = data.results;
      }
    });
  }

  getTypeChargeHotel() {
    this.generalService.listTypeChargeHotel().subscribe({
      next: (data: any) => {
        this.type_charges = data.results;
      }
    });
  }

  changeTypeRate() {
    let val_ = this.item.value.typerate_id;
    this.typeRateObj = this.toolsService.searchObjById(val_, this.type_rates);
    this.companyAgreement = null;
    // type: agreement
    if (this.typeRateObj.id == 3) {
      this.item.patchValue({
        is_agreement: true
      });
      setTimeout(() => {
        this.SearchPartnercompaniesComponent.focused();
      }, 250);
    } else {
      this.item.patchValue({
        is_agreement: false
      });
    }

    if (this.detail_bedrooms.length > 0) {
      this.getUpdatesRatesByTypeRate();
    }
  }

  validationCompanyAgreement() {
    if (this.typeRateObj.id == 3) {
      if (this.companyAgreement == null) {
        let options = {
          title: 'Advertencia !',
          message:
            'Por favor seleccionar empresa para cotejar convenio disponible para la tarifa de habitación'
        };
        this.alert.warning(options);
        return false;
      }
    }
    return true;
  }

  getUpdatesRatesByTypeRate() {
    if (this.validationCompanyAgreement()) {
      let data: any = {};
      data.is_unique = false;
      data.rate_type = this.typeRateObj.value;
      data.detail_bedrooms = this.detail_bedrooms;
      this.hotelbookingService.updateRatesBedroomByTypeRate(data).subscribe({
        next: (data: any) => {
          console.log(data);
          let data_ = data;
          for (let i in data_) {
            for (let j in data_[i].bedroom_selecteds) {
              let new_item = data_[i].bedroom_selecteds[j];
              this.detail_bedrooms[i].bedroom_selecteds[j].daily_rates =
                new_item.daily_rates;
              this.detail_bedrooms[i].bedroom_selecteds[j].rate_type_used =
                new_item.rate_type_used;
              this.detail_bedrooms[i].bedroom_selecteds[j].subtotal =
                new_item.subtotal;
            }
          }
          this.calculateTotal();
          // this.detail_bedrooms = data;
        }
      });
    }
  }

  selectedCompanyAgreementSearch(item_: any) {
    this.companyAgreement = item_;
    if (this.isEdit) {
      this.companyAgreement.document_str = 'DOC: ' + item_.document;
    }
    this.item.patchValue({
      partnercompany_id: this.companyAgreement.id
    });
  }

  removePartner() {
    this.companyAgreement = null;
    this.item.patchValue({
      partnercompany_id: null
    });
    setTimeout(() => {
      this.SearchPartnercompaniesComponent.focused();
    }, 150);
  }

  selectedClientSearch(item_: any) {
    this.clientSelected = item_;
    this.item.patchValue({
      client_id: item_.id
    });

    if (this.isEdit) {
      this.item.patchValue({
        tel_1: item_.cellphone,
        tel_2: item_.telephone
      });
    }
  }

  removeClient() {
    this.clientSelected = null;
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  extendsClient(event: any): void {
    this.selectedClientSearch(event);
  }

  addClientHowGuest() {
    let validate_ = true;
    if (this.detail_guests.length > 0) {
      for (let i in this.detail_guests) {
        if (this.detail_guests[i].is_client_resposible) {
          validate_ = false;
        }
      }
    }
    if (validate_) {
      this.item.patchValue({
        is_client_guest: true
      });
      this.clientSelected.country_id = constants.CLIENT.COUNTRY[0].id;
      this.clientSelected.age_group = constants.CLIENT.AGE_GROUP[0].id;
      this.clientSelected.url_file = null;
      this.clientSelected.is_client_resposible = true;
      console.log(this.clientSelected);

      this.detail_guests.push(this.clientSelected);
    }
  }

  // registro de huesped
  extendsGuests(event: any): void {
    console.log(event);
    if (event.index_preview == null) {
      this.detail_guests.push(event.item);
    } else {
      this.detail_guests[event.index_preview] = event.item;
    }
  }

  editGuests(id: any, index: any) {
    (<any>$('#openExtendsGuests')).modal('show');
    this.GuestsExtendsComponent.editClient(this.detail_guests[index], index);
  }

  removeGuests(id: any, index: any) {
    if (this.detail_guests[index].is_client_resposible) {
      this.item.patchValue({
        is_client_guest: false
      });
    }
    this.detail_guests.splice(index, 1);
  }

  //  end registered guests

  //  Registro de Transfers

  addTransfers() {
    let item_: any = {};
    item_.bookinghotel_id = null;
    item_.typetransfer_id = null;
    item_.placetransfer_id = null;
    item_.reference_place = null;
    item_.date_transfer = null;
    item_.time_transfer = null;
    item_.nro_pax = null;
    item_.observations = null;
    this.detail_transfers.push(item_);
    setTimeout(() => {
      this.initialTypeTransfer(item_);
      this.initialArrivalPlaces(item_);
    }, 100);
  }

  initialTypeTransfer(item: any) {
    var index = this.detail_transfers.indexOf(item);
    var options = constants.HOTEL.TRANSFERS;
    (<any>$('#typeTransferSelected' + index)).html('');
    for (let i in options) {
      let item_ = options[i];
      (<any>$('#typeTransferSelected' + index)).append(
        $('<option>', {
          value: item_.id,
          text: item_.description
        })
      );
    }

    (<any>$('#typeTransferSelected' + index)).val(options[0].id);
    this.detail_transfers[index].typetransfer_id = options[0].id;
  }

  changeTypeTransfer(param: any, index: number): void {
    this.detail_transfers[index].typetransfer_id = param.value;
  }

  initialArrivalPlaces(item: any) {
    var index = this.detail_transfers.indexOf(item);
    var options = this.arrivalplaces;
    (<any>$('#arrivalPlaceSelected' + index)).html('');
    for (let i in options) {
      let item_ = options[i];
      (<any>$('#arrivalPlaceSelected' + index)).append(
        $('<option>', {
          value: item_.id,
          text: item_.description
        })
      );
    }
    (<any>$('#arrivalPlaceSelected' + index)).val(options[1].id);
    this.detail_transfers[index].placetransfer_id = options[1].id;
  }

  changeNroPax(param: any, index: number): void {
    this.detail_transfers[index].nro_pax = param.value;
  }

  changeArrivalPlace(param: any, index: number): void {
    this.detail_transfers[index].placetransfer_id = param.value;
  }

  changeReferencePlace(param: any, index: number): void {
    this.detail_transfers[index].reference_place = param.value;
  }

  changeDateTransfer(param: any, index: number): void {
    this.detail_transfers[index].date_transfer = param.value;
  }

  changeTimeTransfer(param: any, index: number): void {
    this.detail_transfers[index].time_transfer = param.value;
  }

  changeTransferObservations(param: any, index: number): void {
    this.detail_transfers[index].observations = param.value;
  }

  removeTransfers(id: any, index: any) {
    this.detail_transfers.splice(index, 1);
  }

  // end ==============

  // registro de habitaciones

  extendsBedrooms(event: any): void {
    let data_: any = event;
    this.detail_bedrooms.push(data_);

    this.calculateTotal();
    // reformat items de habitaciones elegidas
    setTimeout(() => {
      let last_index = this.detail_bedrooms.length - 1;
      console.log(this.detail_bedrooms.length);
      console.log(last_index);
      this.initialRoomTypeBedroom(last_index);
      this.setDateflatpickrBedroom(last_index, this.thisComponent);
      // this.initialDetailCharges(last_index);
    }, 250);
  }

  initialDetailCharges(index_core: any) {
    for (let j in this.detail_bedrooms[index_core].bedroom_selecteds) {
      this.detail_bedrooms[index_core].bedroom_selecteds[j].detail_charges = [];
    }
  }

  initialRoomTypeBedroom(index_core: any) {
    for (let j in this.detail_bedrooms[index_core].bedroom_selecteds) {
      let bedroom = this.detail_bedrooms[index_core].bedroom_selecteds[j];
      let options_arr: any = [];
      options_arr.push(bedroom.roomtype);
      if (bedroom.is_variation_roomtype) {
        for (let k in bedroom.bedroom_variations) {
          options_arr.push(bedroom.bedroom_variations[k].roomtype);
        }
      }
      var options = options_arr;
      (<any>$('#roomTypeSelected' + index_core + j)).html('');
      for (let i in options) {
        let item_ = options[i];
        (<any>$('#roomTypeSelected' + index_core + j)).append(
          $('<option>', {
            value: item_.id,
            text: item_.description
          })
        );
      }
      (<any>$('#roomTypeSelected' + index_core + j)).val(bedroom.roomtype_id);
      this.detail_bedrooms[index_core].bedroom_selecteds[j].roomtype_id =
        bedroom.roomtype_id;
    }
  }

  changeRoomTypeBedroom(param: any, index_core: number, index: number): void {
    if (this.validationCompanyAgreement()) {
      let value_ = param.value;
      let roomtype_ = this.toolsService.searchObjById(value_, this.roomtypes);
      this.detail_bedrooms[index_core].bedroom_selecteds[
        index
      ].roomtype_id = Number(value_);
      this.detail_bedrooms[index_core].bedroom_selecteds[
        index
      ].roomtype = roomtype_;
      // actualizar acorde al cambio de tipo de habitación ========
      this.updateRateByBedroomUnique(index_core, index);
    }
  }

  setDateflatpickrBedroom(index_core: any, component: any) {
    for (let j in this.detail_bedrooms[index_core].bedroom_selecteds) {
      const checkinSelector = '#date_checkin' + index_core + j;
      const checkoutSelector = '#date_checkout' + index_core + j;
      const detail = this.detail_bedrooms[index_core].bedroom_selecteds[j]; // referencia al objeto actual
      let checkinPicker: any;
      let checkoutPicker: any;

      // Inicializa el checkout primero
      checkoutPicker = flatpickr(checkoutSelector, {
        altInput: true,
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
        enableTime: false,
        minDate: new Date(),
        onChange: function(selectedDates) {
          if (selectedDates.length > 0 && checkinPicker) {
            const checkinDate = checkinPicker.selectedDates[0];
            const checkoutDate = selectedDates[0];

            component.setDateCheckin(
              index_core,
              j,
              moment(checkinDate).format('YYYY-MM-DD')
            );
            component.setDateCheckout(
              index_core,
              j,
              moment(checkoutDate).format('YYYY-MM-DD')
            );

            if (checkinDate) {
              // Calcular diferencia en días
              const diffTime = checkoutDate.getTime() - checkinDate.getTime();
              const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              detail.number_nights = nights > 0 ? nights : 0;
              component.setNightsBedroom(index_core, j, detail.number_nights);
            }
          }
        }
      });

      // Inicializa el checkin
      checkinPicker = flatpickr(checkinSelector, {
        altInput: true,
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
        enableTime: false,
        onChange: function(selectedDates) {
          if (selectedDates.length > 0) {
            const checkinDate = selectedDates[0];
            component.setDateCheckin(
              index_core,
              j,
              moment(checkinDate).format('YYYY-MM-DD')
            );

            const nextDay = new Date(checkinDate);
            nextDay.setDate(nextDay.getDate() + 1); // +1 día

            // 🔥 Forzamos que checkout tenga como mínimo el día siguiente
            checkoutPicker.set('minDate', nextDay);
            checkoutPicker.setDate(nextDay, true); // cambia automáticamente el checkout

            // Actualiza las noches automáticamente
            detail.number_nights = 1;
            component.setNightsBedroom(index_core, j, detail.number_nights);
          }
        }
      });
    }
  }

  setDateCheckin(index_core: number, index: number, date_checkin: any): void {
    this.detail_bedrooms[index_core].bedroom_selecteds[
      index
    ].date_checkin = date_checkin;
  }

  setDateCheckout(index_core: number, index: number, date_checkout: any): void {
    this.detail_bedrooms[index_core].bedroom_selecteds[
      index
    ].date_checkout = date_checkout;
  }

  changeTypeCharge(param: any, index_core: number, index: number): void {
    let value_ = param.value;
    if (value_ !== 'null') {
      let type_ = this.toolsService.searchObjById(value_, this.type_charges);
      if (
        this.toolsService.notExistObjInArr(
          type_,
          this.detail_bedrooms[index_core].bedroom_selecteds[index]
            .detail_charges
        )
      ) {
        let obj_: any = {};
        obj_.id = type_.id;
        obj_.detailbedroom_id = null;
        obj_.typecharge_id = type_.id;
        obj_.description = type_.description;
        obj_.is_additional_pax = type_.is_additional_pax;
        obj_.quantity = 1;
        obj_.price = type_.price;
        obj_.total = Number(type_.price * 1);
        obj_.observation = null;

        // if(type_.is_additional_pax){
        //   let nro_pax = Number(this.detail_bedrooms[index_core].bedroom_selecteds[index].nro_pax) + obj_.quantity;
        // }

        this.detail_bedrooms[index_core].bedroom_selecteds[
          index
        ].detail_charges.push(obj_);
        this.calculateTotal();
      }

      setTimeout(() => {
        (<any>$('#selectTypeCharge' + index_core + index)).val('null');
      }, 100);
    }
  }

  quantityTypeCharge(
    param: any,
    index_core: number,
    index: number,
    index_charge: any
  ): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_bedrooms[index_core].bedroom_selecteds[index].detail_charges[
        index_charge
      ].quantity = value_;
      let price_ = this.detail_bedrooms[index_core].bedroom_selecteds[index]
        .detail_charges[index_charge].price;
      let total_ = Number(value_) * Number(price_);
      this.detail_bedrooms[index_core].bedroom_selecteds[index].detail_charges[
        index_charge
      ].total = total_;

      this.calculateTotal();
    }
  }

  removeTypeCharge(id: any, index_core: number, index: any, index_charge: any) {
    this.detail_bedrooms[index_core].bedroom_selecteds[index][
      'detail_charges'
    ].splice(index_charge, 1);
    this.calculateTotal();
  }

  setNightsBedroom(index_core: number, index: number, nights: number) {
    console.log(nights);
    this.detail_bedrooms[index_core].bedroom_selecteds[
      index
    ].number_nights = nights;

    // actualizar acorde al cambio de fechas ========
    this.updateRateByBedroomUnique(index_core, index);
  }

  updateRateByBedroomUnique(index_core: number, index: number) {
    let data: any = {};
    data.is_unique = true;
    data.rate_type = this.typeRateObj.value;
    data.detail_bedrooms = this.detail_bedrooms[index_core].bedroom_selecteds[
      index
    ];

    this.hotelbookingService.updateRatesBedroomByTypeRate(data).subscribe({
      next: (data: any) => {
        this.detail_bedrooms[index_core].bedroom_selecteds[index].daily_rates =
          data.daily_rates;
        this.detail_bedrooms[index_core].bedroom_selecteds[
          index
        ].rate_type_used = data.rate_type_used;
        this.detail_bedrooms[index_core].bedroom_selecteds[index].subtotal =
          data.subtotal;
        this.calculateTotal();
      }
    });
  }

  removeBedroomSelected(id: any, index_core: number, index: any) {
    if (this.detail_bedrooms[index_core]['bedroom_selecteds'].length > 1) {
      this.detail_bedrooms[index_core]['bedroom_selecteds'].splice(index, 1);
      this.calculateTotal();
    } else {
      let options = {
        title: 'Advertencia !',
        message:
          'El detalle del bloque de habitaciones no puede estar vacío; considera eliminar el bloque completo'
      };
      this.alert.warning(options);
    }
  }

  detailRateBedroom(index_core: number, index: any) {
    this.bedroomSelected = this.detail_bedrooms[index_core].bedroom_selecteds[
      index
    ];
  }

  removedetailRateBedroom() {
    (<any>$('#modalNights')).modal('hide');
    this.bedroomSelected = null;
  }

  removeBlockBedrooms(index: any) {
    this.detail_bedrooms.splice(index, 1);
    this.calculateTotal();
  }

  calculateTotal() {
    this.total = 0;
    this.total_bedrooms = 0;
    this.total_pax = 0;

    for (let i in this.detail_bedrooms) {
      let item_ = this.detail_bedrooms[i];
      for (let j in item_.bedroom_selecteds) {
        let bedroom_ = item_.bedroom_selecteds[j];

        // sum total pax:
        this.total_pax = this.total_pax + Number(bedroom_.roomtype.capacity);

        let total_charges = 0;
        if (bedroom_.detail_charges.length > 0) {
          for (let c in bedroom_.detail_charges) {
            let charge = bedroom_.detail_charges[c];
            total_charges =
              total_charges +
              Number(charge.total) * Number(bedroom_.number_nights);
            if (charge.is_additional_pax) {
              this.total_pax = this.total_pax + Number(charge.quantity);
            }
          }
        }

        let past_subtotal = 0;
        for (let c in bedroom_.daily_rates) {
          past_subtotal = past_subtotal + Number(bedroom_.daily_rates[c].rate);
        }
        this.detail_bedrooms[i].bedroom_selecteds[j].subtotal = past_subtotal;

        let summary_total = total_charges + Number(bedroom_.subtotal);
        this.detail_bedrooms[i].bedroom_selecteds[j].subtotal = summary_total;
        this.total_bedrooms = this.total_bedrooms + Number(summary_total);
      }

      this.total = this.total + this.total_bedrooms;
      this.item.patchValue({
        total: this.total
      });
    }
  }

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;
    this.selectedFiles = Array.from(input.files);

    // (Opcional) puedes filtrar si necesitas
    // Ejemplo: separar imágenes y PDFs
    // const imagenes = this.selectedFiles.filter(f => f.type.startsWith('image/'));
    // const documentos = this.selectedFiles.filter(f => f.type === 'application/pdf');

    console.log('Archivos seleccionados:', this.selectedFiles);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));
      formData.append('detail_bedrooms', JSON.stringify(this.detail_bedrooms));
      formData.append('detail_guests', JSON.stringify(this.detail_guests));
      formData.append(
        'detail_transfers',
        JSON.stringify(this.detail_transfers)
      );

      // Archivos seleccionados
      if (this.selectedFiles && this.selectedFiles.length > 0) {
        this.selectedFiles.forEach((file: File) => {
          formData.append('files[]', file); // 🔹 usa el mismo nombre que espera tu backend
        });
      }
      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.hotelbookingService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.hotelbookingService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    let item_ = this.item.value;

    if (_.isNull(item_.client_id)) {
      this.alertifyMsg.warning(
        'Debe seleccionar un cliente titular para la reserva.'
      );
      this.SearchClientComponent.focused();
      return false;
    }

    if (item_.is_agreement) {
      if (_.isNull(item_.partnercompany_id)) {
        this.alertifyMsg.warning(
          'Debe seleccionar una empresa para aplicar la tarifa convenio'
        );
        this.SearchPartnercompaniesComponent.focused();
        return false;
      }
    }

    if (this.detail_bedrooms.length == 0) {
      let options = {
        title: 'Advertencia !',
        message: 'El detalle de habitaciones no puede estar vacío'
      };
      this.alert.warning(options);
      return false;
    }

    if (this.detail_guests.length == 0) {
      let options = {
        title: 'Advertencia !',
        message: 'El detalle de huéspedes de la reserva no puede estar vacío'
      };
      this.alert.warning(options);
      return false;
    }

    if (this.detail_transfers.length > 0) {
      for (let i in this.detail_transfers) {
        let transfer = this.detail_transfers[i];
        if (_.isNull(transfer.nro_pax)) {
          this.alertifyMsg.warning(
            'Debe especificar la cantidad de personas para el transfer'
          );
          (<any>$('#nro_pax' + i)).focus();
          return false;
        }

        if (_.isNull(transfer.date_transfer)) {
          this.alertifyMsg.warning(
            'Debe especificar la fecha para el transfer'
          );
          (<any>$('#date_transfer' + i)).focus();
          return false;
        }

        if (_.isNull(transfer.time_transfer)) {
          this.alertifyMsg.warning('Debe especificar la hora para el transfer');
          (<any>$('#time_transfer' + i)).focus();
          return false;
        }
      }
    }
    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/reservashotel/reservas/lista'
    ]);
  }
}
